import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/home'

import AjusaTH from '@/components/views/ajusa-th'
import Tecnologia from '@/components/views/tecnologia'
import Productos from '@/components/views/productos'
import Proyectos from '@/components/views/proyectos'

import Contacto from '@/components/views/contacto'
import TrabajaConNosotros from '@/components/views/trabaja-con-nosotros'

import Error404 from '@/components/views/error-404'

import politicaCookies from '@/components/views/politica-de-cookies'
import politicaPrivacidad from '@/components/views/politica-de-privacidad'
import MapaWeb from '@/components/views/mapa-web'
import AvisoLegal from '@/components/views/aviso-legal'
import DatosSeguros from '@/components/views/datos-seguros'

import ENpoliticaCookies from '@/components/views/politica-cookies-en'
import ENpoliticaPrivacidad from '@/components/views/politica-privacidad-en'
import ENAvisoLegal from '@/components/views/aviso-legal-en'
import ENDatosSeguros from '@/components/views/datos-seguros-en'

Vue.use(Router)


import messages from '@/translations';

let en = messages.en.enlaces;
let es = messages.es.enlaces;

const router = new Router({
	mode : 'history',
	routes: [
	{
		path: '/',
		name: 'home',
		component: Home
	},
	{
		path: es.ajusath,
		alias: en.ajusath,
		name: 'ajusath',
		component: AjusaTH
	},
	{
		path: es.tecnologia,
		alias: en.tecnologia,
		name: 'tecnologia',
		component: Tecnologia
	},
	{
		path: es.productos,
		alias: en.productos,
		name: 'productos',
		component: Productos
	},
	{
		path: es.proyectos,
		alias: en.proyectos,
		name: 'proyectos',
		component: Proyectos
	},
	{
		path: es.contacto,
		alias: en.contacto,
		name: 'contacto',
		component: Contacto
	},
	{
		path: es.trabaja_con_nosotros,
		alias: en.trabaja_con_nosotros,
		name: 'trabaja con nosotros',
		component: TrabajaConNosotros
	},
	{
		path: es.politica_privacidad,
		name: 'politica-de-privacidad',
		component: politicaPrivacidad
	},
	{
		path: en.politica_privacidad,
		name: 'politica-de-privacidad-en',
		component: ENpoliticaPrivacidad
	},
	{
		path: es.politica_cookies,
		name: 'politica-de-cookies',
		component: politicaCookies
	},
	{
		path: en.politica_cookies,
		name: 'politica-de-cookies-en',
		component: ENpoliticaCookies
	},
	{
		path: es.aviso_legal,
		name: 'aviso-legal',
		component: AvisoLegal,
	},
	{
		path: en.aviso_legal,
		name: 'aviso-legal-en',
		component: ENAvisoLegal,
	},
	{
		path: es.mapa_web,
		alias: en.mapa_web,
		name: 'mapa-web',
		component: MapaWeb,
	},
	{
		path: es.datos_seguros,
		name: 'tus-datos-seguros',
		component: DatosSeguros,
	},
	{
		path: en.datos_seguros,
		name: 'tus-datos-seguros-en',
		component: ENDatosSeguros,
	},
	{ path: '*', redirect: '/404' },
	{ path: "/404", component: Error404 }
	],
	scrollBehavior (to, from, savedPosition) {
		if(savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
})


import VueAnalytics from 'vue-analytics';

Vue.use(VueAnalytics, {
  id: 'UA-126353823-1',
  // id : 'UA-126321233-1', pruebas
  router,
  debug : {
  	sendHitTask: location.hostname.includes('ajusath.es'),
  	enabled : !location.hostname.includes('ajusath.es')
  }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js